import React, { useMemo } from 'react';
import classnames from 'classnames/bind';
import CardItem from './CardItem';
import { CustomerStatus } from 'common/consts/customerStatus';
import styles from './OptionsCards.module.scss';

interface Props {
  PageData?: any;
  Model?: any;
}

const cx = classnames.bind(styles);

const OptionsCards = ({
  PageData,
  Model,
}: Props) => {
  const showPaymentPlan = Model?.DebtOverviewPanelViewModel?.SinglePaymentBtnVisible;
  const noOfCardDisplayed = useMemo(() => {
    let val = 0;
    if (showPaymentPlan) {
      ++val;
    }
    if (Model?.DebtOverviewPanelViewModel?.PayYourBalanceFullBtnVisible && !Model?.HasOffer && !Model?.WithDiscount && !Model?.HideCardsExceptPayerReview) {
      ++val;
    }
    if (Model?.PaymentPlan !== null && !Model?.HideCardsExceptPayerReview && Model.IsTotalBalanceHigherThanMinimumBalance) {
      if (((Model?.PaymentPlan?.NoPaymentPlan || Model?.IsCmsEditMode) && 
            Model.CustomerStatus !== CustomerStatus.ClosingInProgress) || !Model?.PaymentPlan?.NoPaymentPlan) {

          if(!Model?.PaymentPlan?.NoPaymentPlan  && Model.HidePaymentPlanEdit && Model.IsSecuredUser)
            {	            
		          return val;	              
            }
        ++val;
      }
    }
    return val;
  }, [Model]);
  const wrapperStyle = cx({
    OptionsCards: true,
    twoInRow: noOfCardDisplayed === 2,
    oneInRow: noOfCardDisplayed === 1,
  });
  return (
    <div className={wrapperStyle}>
      {(Model?.DebtOverviewPanelViewModel?.PayYourBalanceFullBtnVisible && !Model?.HasOffer && !Model?.WithDiscount && !Model?.HideCardsExceptPayerReview) &&
        <CardItem
          heading={PageData?.PayBalanceFullHeadingText}
          paragraphs={[PageData?.PayBalanceFullParagraphText]}
          buttonText={PageData?.PayBalanceFullButtonText}
          buttonUrl={`${Model?.SinglePaymentPage?.Uri}&payFullBalance=True`}
          style={{ order: `${Model?.DisplayCardsOrderingFullBalance}` }}
        />
      }
      {(Model.PaymentPlan !== null && Model.CustomerStatus !== CustomerStatus.ClosingInProgress && Model.IsTotalBalanceHigherThanMinimumBalance && !Model.HideCardsExceptPayerReview) &&
        (Model.PaymentPlan.NoPaymentPlan || Model.IsCmsEditMode) &&
        <CardItem
          heading={PageData?.SetupPaymentPlanHeadingText}
          list={[PageData?.SetupPaymentPlanFirstLineText, PageData?.SetupPaymentPlanSecondLineText]}
          buttonText={PageData?.NoPaymentplanButtonLabel}
          buttonUrl={Model?.DebtOverviewPanelViewModel?.SetUpPaymentPlanStartPageUrl}
          style={{ order: `${Model?.DisplayCardsOrderingCreateOrUpdatePaymentPlan}` }}
        />
      }
      {(Model.PaymentPlan !== null && !Model.PaymentPlan.NoPaymentPlan && Model.IsTotalBalanceHigherThanMinimumBalance) &&
        <>
        {(!Model.HidePaymentPlanEdit && !Model.HideCardsExceptPayerReview) ?
          <CardItem
            heading={PageData?.UpdatePaymentPlanHeading}
            paragraphs={[
              PageData?.UpdatePaymentPlanParagraphText,
              Model?.IsPlanUpdateUpcomingPaymentNotAllowed && PageData?.UpcomingPaymentProcessingMessage,
              Model?.IsPlanUpdateNextInstalmentNotAllowed && PageData?.NextInstallmentUpdateNotAllowedMessage,
            ]}
            buttonText={PageData?.ChangePaymentPlanLinkText}
            buttonUrl={Model?.DebtOverviewPanelViewModel?.ChangePaymentPlanUrl}
            disabled={(Model?.IsPlanUpdateUpcomingPaymentNotAllowed || Model?.IsPlanUpdateNextInstalmentNotAllowed)}
            style={{ order: `${Model?.DisplayCardsOrderingCreateOrUpdatePaymentPlan}`}}
          /> :
         (!Model?.IsSecuredUser) ? 
          <CardItem
            heading={PageData?.ContactUsHeading}
            paragraphs={[PageData?.ContactUsParagraphText]}
            buttonText={PageData?.ContactUsLinkText}
            buttonUrl={PageData?.ContactUsLink?.Uri}
          />
          :
          null
        }
        </>
      }
      {(showPaymentPlan && !Model.HideCardsExceptPayerReview) &&
        <CardItem
          heading={PageData?.MakeAPaymentHeading}
          paragraphs={[PageData?.MakeOneOffPaymentParagraphText]}
          buttonText={PageData?.MakeAPaymentButtonLabel}
          buttonUrl={`${Model?.SinglePaymentPage?.Uri}&isDirectPayment=True`}
          style={{ order: `${Model?.DisplayCardsOrderingMakePayment}` }}
        />
      }
    </div>
  );
};

export default OptionsCards;
